<template>
  <!-- Add Banked Time Modal -->
  <div id="add_banked_time" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Banked Time</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="addBankedTime">
            
            

            <div class="input-block mb-3">
              <label class="col-form-label"
                >Date<span class="text-danger">*</span></label
              >
              <div class="cal-icon">
                <date-picker
                  v-model="bankedTimeDate"
                  class="form-control datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                />
              </div>
            </div>

            <div class="submit-section">
              <button type="submit" data-bs-dismiss="modal" class="btn btn-primary submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Banked Time Modal -->

 
</template>

<script>
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../config";
export default {
  data() {
    return {
      select2: null,
      // loader:false,
      dateFormat: 'dd-MM-yyyy',
      bankedTimeDate: null,
      user_id:''
    };
  },
  mounted() {
   
  },
  methods:{
    
   

   
    updateValues(data){
        this.user_id = data[0].id
        console.log(this.user_id);
    },
  
    async addBankedTime() {
      // this.loader = true;

      const data = {
        user_ids:[this.user_id],
        date:this.bankedTimeDate
      }
      // add start_date and end_date conditionally
      
      
      await axios.post(`${VUE_APP_API_BASE_URL}/task/add`, data)
        .then((response) => {
          if (response.data.status === true) {
            this.$toast.success(response.data.message);
            // this.$emit("leave application sent");
            this.$refs.Close.click();
            this.$router.go(0)
            // this.loader = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            // this.loader = false;
            // this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
          // this.loader = false;
        });
    },

    
  },

};
</script>
